import { ContentBox, useBreadcrumbTitle } from "@msuite/ui/app-shell";
import { useTranslation } from "@msuite/ui/localization";
import { Tabs } from "@msuite/ui/tabs";
import { useParams } from "react-router";
import { useLoadCarrier } from "@/hooks/use-load-carrier";
import { LoadCarrierGeneral } from "./load-carrier-general";
import { LoadCarrierTransactions } from "./load-carrier-transactions";

export function LoadCarrier() {
	/** Hooks */
	const loadCarrierId = useParams().loadCarrierId as string;
	const { t } = useTranslation();
	const { loadCarrier } = useLoadCarrier(loadCarrierId);
	useBreadcrumbTitle(loadCarrierId, loadCarrier?.name);

	/** Render */
	return (
		<ContentBox>
			<Tabs
				groups={[
					{
						name: "general",
						panels: [
							{
								label: t("general.general"),
								panel: () => <LoadCarrierGeneral loadCarrierId={loadCarrierId} />,
								cyId: "general-tab",
								errors: [],
							},
						],
					},
					{
						name: "details",
						panels: [
							{
								label: t("stock.transactions"),
								panel: () => <LoadCarrierTransactions loadCarrierId={loadCarrierId} />,
								cyId: "transactions-tab",
								errors: [],
							},
						],
					},
				]}
			/>
		</ContentBox>
	);
}
